const useIsDemoInstance = () => {
  return (
    window.location.hostname.includes("demo") ||
    window.location.hostname.includes("localhost")
  );
};

export default useIsDemoInstance;
